import { useEffect, useState } from "react";
import { FaLink } from "react-icons/fa";
import { toast } from "react-toastify";

const Share = (props) => {
  const [shareUrl, setShareUrl] = useState("");
  useEffect(() => {
	let isMounted = true; // Avoid setting state after unmount
  
	if (props.id && props.type) {
    const fullUrl = `https://admin-stage.nris.com/api/v1/share?type=${props.type}&id=${props.id}`;
	//   fetch("https://cleanuri.com/api/v1/shorten", {
	// 	method: "POST",
	// 	headers: { "Content-Type": "application/x-www-form-urlencoded" },
	// 	body: new URLSearchParams({
	// 	  url: `https://admin-stage.nris.com/api/v1/share/${props.id}`,
	// 	}),
	//   })
	// 	.then((response) => response.json())
	// 	.then((data) => {
	// 	  if (isMounted) {
	// 		setShareUrl(data.result_url);
	// 	  }
	// 	})
	// 	.catch((error) => {
	// 	  console.error("Error shortening URL:", error);
	// 	  if (isMounted) {
	// 		setShareUrl(props.url);
	// 	  }
	// 	});
  fetch(`https://tinyurl.com/api-create.php?url=${encodeURIComponent(fullUrl)}`)
  .then(res => res.text())
  .then(shortUrl => setShareUrl(shortUrl));

	} else if (props.url) {
	  setShareUrl(props.url);
	}
  
	return () => {
	  isMounted = false;
	};
  }, [props.id, props.type, props.url]);

  
  const copyLink = () => {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => toast.success("Link copied."));
  };

  return (
    <>
      <div className="mt-3">
        <i
          class="fi fi-sr-share-alt-square cursor-pointer"
          style={{ fontSize: "30px" }}
          data-bs-toggle="modal"
          data-bs-target="#shareModal"
        ></i>
      </div>
      <div
        className="modal fade pe-0"
        id="shareModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <button
              className="btn-close"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="modal-header d-block text-center border-bottom-0">
              <h5 className="text-brand-1">Share your thoughts.</h5>
            </div>
            <div className="modal-body px-4 pb-4">
              <div className=" d-block text-center mt-2 mb-3">
                <ul className="social-list">
                  <li>
                    <span
                      onClick={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                            shareUrl
                          )}`
                        );
                      }}
                    >
                      <i
                        class="fi fi-brands-facebook cursor-pointer"
                        style={{ fontSize: "35px" }}
                      ></i>
                    </span>
                  </li>
                  <li>
                    <span
                      onClick={() => {
                        window.open(
                          `whatsapp://send?text=${encodeURIComponent(shareUrl)}`
                        );
                      }}
                    >
                      <i
                        class="fi fi-brands-whatsapp cursor-pointer"
                        style={{ fontSize: "35px" }}
                      ></i>
                    </span>
                  </li>
                  <li>
                    <span
                      onClick={() => {
                        window.open(
                          `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                            shareUrl
                          )}`
                        );
                      }}
                    >
                      <i
                        class="fi fi-brands-twitter-alt-circle cursor-pointer"
                        style={{ fontSize: "35px" }}
                      ></i>
                    </span>
                  </li>
                  <li>
                    <span
                      onClick={() => {
                        window.open(
                          `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
                            shareUrl
                          )}`
                        );
                      }}
                    >
                      <i
                        class="fi fi-brands-pinterest cursor-pointer"
                        style={{ fontSize: "35px" }}
                      ></i>
                    </span>
                  </li>
                </ul>
                <div className="col-12 mt-4">
                  <label htmlFor="shareLink">Or copy this link to share</label>
                  <div className="input-group">
                    <input
                      id="shareLink"
                      className="form-control bg-transparent"
                      placeholder="Link"
                      readOnly={true}
                      value={shareUrl}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={copyLink}
                    >
                      <FaLink />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Share;
